import { defineStore } from "pinia";

export const useMyAccountStore = defineStore("myaccount", {
  state: () => ({
    isMyAccount: false,
    myAccountSelection: {},
    myAccountUploadPath: "",
    myAccountUploadedFiles: {}
  }),

  getters: {
    getIsMyAccount(state) {
      return state.isMyAccount;
    },
    getMyAccountSelection(state) {
      return state.myAccountSelection;
    },
    getMyAccountUploadPath(state) {
      return state.myAccountUploadPath;
    },
    getMyAccountUploadedFiles(state) {
      return function (code) {
        for (var i in state.myAccountUploadedFiles) {
          if (code == state.myAccountUploadedFiles[i].code) {
            return { ...state.myAccountUploadedFiles[i], file: i };
          }
        }
        return null;
      };
    }
  },

  actions: {
    setIsMyAccount(payload) {
      this.isMyAccount = payload;
    },
    setMyAccountSelection(payload) {
      this.myAccountSelection = payload;
    },
    setMyAccountUploadedFiles(payload) {
      this.myAccountUploadedFiles = payload;
    },
    setMyAccountUploadPath(payload) {
      this.myAccountUploadPath = payload;
    },
    setMyAccount(payload) {
      if (payload.isMyAccount) {
        this.setIsMyAccount(payload.isMyAccount);
        if (payload.myAccountSelection) {
          this.setMyAccountSelection(payload.myAccountSelection);
        }
        if (payload.myAccountUploadedFiles) {
          this.setMyAccountUploadedFiles(payload.myAccountUploadedFiles);
        }
        if (payload.myAccountUploadPath) {
          this.setMyAccountUploadPath(payload.myAccountUploadPath);
        }
      }
    }
  }
});
